"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partnerWithUsFormReducer = void 0;
const ts_pattern_1 = require("ts-pattern");
const state_1 = require("../../redux/state");
const partnerWithUsFormReducer = (state) => (action) => (0, ts_pattern_1.match)(action)
    .with({ type: 'SET_PARTNER_WITH_US_FORM_SUBMIT' }, (_action) => state.update(state_1.stateKeys.partnerWithUsForm, (_state) => ({
    ..._state,
    submitted: _action.payload
})))
    .with({ type: 'SET_PARTNER_WITH_US_FORM_ERROR' }, (_action) => state.update(state_1.stateKeys.partnerWithUsForm, (_state) => ({
    ..._state,
    error: _action.payload
})))
    .with({ type: 'SET_PARTNER_WITH_US_FORM_SUCCESS' }, (_action) => state.update(state_1.stateKeys.partnerWithUsForm, (_state) => ({
    ..._state,
    value: _action.payload
})))
    .exhaustive();
exports.partnerWithUsFormReducer = partnerWithUsFormReducer;
//# sourceMappingURL=reducer.js.map